/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditListRequest {
    getFixupPrototypeFunction() { return RequestAuditListRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditListRequest>): RequestAuditListRequest {
        let obj = Object.assign(new RequestAuditListRequest(), model);
        RequestAuditListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditListRequest>): RequestAuditListRequest {
        if (!model) return null;
        return RequestAuditListRequest.newInstance(<RequestAuditListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditListRequest) {
        if (!obj) return;

        models.RequestAuditListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditListRequest): boolean {
        Object.setPrototypeOf(obj, RequestAuditListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.RequestAuditFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.RequestAuditSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.RequestAuditSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.RequestAuditFilter;

}
